if(!customElements.get('util-accordion')) {
    class UtilAccordion extends HTMLElement {
      constructor() {
        super();
        var self = this;
        var expandMultiple = this.dataset.expandMultiple=='true';
        var filter = this.querySelector('.category-filter');
        var scrollToSelf = this.dataset.scrollToSelf;
        this.accordions = this.querySelectorAll('.accordion');

        this.inCard = this.dataset.inCard;
        if(this.inCard){
          this.closestCardContainer = this.closest('.card-container');
        }

        if (filter) {
          filter.addEventListener('change', ()=>{
            this.accordions.forEach(function(accordionItem){
              accordionItem.style.display = accordionItem.dataset.category==filter.value ? '' : 'none';
            });
          });
        }
        this.accordions.forEach(function(accordionItem) {
          var button = accordionItem.querySelector('button[aria-expanded]');
          var panel = accordionItem.querySelector('[role="region"]');
          button.addEventListener('click', function(event) {
            if (button.getAttribute('aria-expanded')=='true') {
              button.setAttribute('aria-expanded', 'false');
              accordionItem.classList.remove('open');
              if(self.closestCardContainer)
                self.closestCardContainer.classList.remove('open');

              $s.collapse(panel);
            } else {
              if(scrollToSelf)
                $s.scrollToElement(button, Number(scrollToSelf));
              button.setAttribute('aria-expanded', 'true');
              accordionItem.classList.add('open');

              if(self.closestCardContainer)
                self.closestCardContainer.classList.add('open');

              $s.expand(panel);
              if (!expandMultiple) {
                //close other panels
                var allButtonsExpanded = self.querySelectorAll((filter ? '[data-category="'+accordionItem.dataset.category+'"] ' : '') + 'button[aria-expanded="true"]');
                allButtonsExpanded.forEach(function(buttonExpanded) {
                  if (buttonExpanded!=button) {
                    var thisAccordion = buttonExpanded.closest('.accordion');
                    var thisPanel = thisAccordion.querySelector('[role="region"]');
                    buttonExpanded.setAttribute('aria-expanded', 'false');
                    thisAccordion.classList.remove('open');
                    if(self.closestCardContainer)
                      self.closestCardContainer.classList.remove('open');
                    $s.collapse(thisPanel);
                  }
                })
              }
            }
          });
        });
      }
  
    }
    customElements.define('util-accordion', UtilAccordion);
  
  }